import { useCallback, useState } from 'react';
import { availableMachines } from '@reducers/machines';
import { useAppDispatch } from '@store/hooks/useAppDispatch';

import { RequestInfo } from './types';

const useDispatchRequest = () => {
  const dispatch = useAppDispatch();

  const [requestData, setRequestData] = useState<RequestInfo | null>(null);

  const send = useCallback(async (url: string) => {
    const startTime = performance.now();
    setRequestData({
      method: 'POST',
      url: url,
      status: 'pending',
      startTime,
    });

    try {
      const responseStartTime = performance.now();
      const response = await dispatch(availableMachines());

      const responseBody = JSON.stringify(response);
      const responseSize = new Blob([responseBody]).size;

      const responseTime = performance.now() - responseStartTime;

      setRequestData({
        method: 'POST',
        url: url,
        status: 'completed',
        statusCode: 200,
        headers: {},
        responseTime,
        responseSize,
        responseBody,
        startTime,
      });
    } catch (error) {
      setRequestData({
        method: 'POST',
        url: url,
        status: 'error',
        error: error instanceof Error ? error.message : 'Unknown error',
        startTime,
      });
    }
  }, []);

  return [requestData, send] as const;
};

export default useDispatchRequest;
